import jade from 'javascripts/confirmation_banner/templates/below_nav_view.jst.jade';
window.JST = window.JST || {};
window.JST['confirmation_banner/templates/below_nav_view'] = jade;
